/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as ForbiddenRouteImport } from './app/routes/forbidden'
import { Route as AuthRouteImport } from './app/routes/auth'
import { Route as AtivarPainelOperacaoRouteImport } from './app/routes/ativar-painel-operacao'
import { Route as ProtectedRouteImport } from './app/routes/_protected'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as ProtectedInicioRouteImport } from './app/routes/_protected/inicio'
import { Route as ProtectedProgramIdRouteImport } from './app/routes/_protected/$programId'
import { Route as ProtectedProgramIdVisoesRouteImport } from './app/routes/_protected/$programId/visoes'
import { Route as ProtectedProgramIdRoteirosDaSemanaRouteImport } from './app/routes/_protected/$programId/roteiros-da-semana'
import { Route as ProtectedProgramIdRelatoriosRouteImport } from './app/routes/_protected/$programId/relatorios'
import { Route as ProtectedProgramIdPlanejamentoDeRoteirosRouteImport } from './app/routes/_protected/$programId/planejamento-de-roteiros'
import { Route as ProtectedProgramIdIndisponibilidadeDeElencoRouteImport } from './app/routes/_protected/$programId/indisponibilidade-de-elenco'
import { Route as ProtectedProgramIdIndicadoresRouteImport } from './app/routes/_protected/$programId/indicadores'
import { Route as ProtectedProgramIdFotosRouteImport } from './app/routes/_protected/$programId/fotos'
import { Route as ProtectedProgramIdCapitulosECenasRouteImport } from './app/routes/_protected/$programId/capitulos-e-cenas'
import { Route as ProtectedProgramIdEprodIndexRouteImport } from './app/routes/_protected/$programId/eprod/index'
import { Route as ProtectedProgramIdDecupagensFigurinoRouteImport } from './app/routes/_protected/$programId/decupagens/figurino'
import { Route as ProtectedProgramIdDecupagensEfeitosRouteImport } from './app/routes/_protected/$programId/decupagens/efeitos'
import { Route as ProtectedProgramIdDecupagensContinuidadeRouteImport } from './app/routes/_protected/$programId/decupagens/continuidade'
import { Route as ProtectedProgramIdDecupagensArteRouteImport } from './app/routes/_protected/$programId/decupagens/arte'
import { Route as ProtectedProgramIdDecupagensBasicaIndexRouteImport } from './app/routes/_protected/$programId/decupagens/basica/index'
import { Route as ProtectedProgramIdEprodScriptIdPainelRouteImport } from './app/routes/_protected/$programId/eprod/$scriptId/painel'
import { Route as ProtectedProgramIdDecupagensBasicaChapterNumberRouteImport } from './app/routes/_protected/$programId/decupagens/basica/$chapterNumber'

const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AtivarPainelOperacaoRoute = AtivarPainelOperacaoRouteImport.update({
  id: '/ativar-painel-operacao',
  path: '/ativar-painel-operacao',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedInicioRoute = ProtectedInicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProgramIdRoute = ProtectedProgramIdRouteImport.update({
  id: '/$programId',
  path: '/$programId',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProgramIdVisoesRoute =
  ProtectedProgramIdVisoesRouteImport.update({
    id: '/visoes',
    path: '/visoes',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdRoteirosDaSemanaRoute =
  ProtectedProgramIdRoteirosDaSemanaRouteImport.update({
    id: '/roteiros-da-semana',
    path: '/roteiros-da-semana',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdRelatoriosRoute =
  ProtectedProgramIdRelatoriosRouteImport.update({
    id: '/relatorios',
    path: '/relatorios',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdPlanejamentoDeRoteirosRoute =
  ProtectedProgramIdPlanejamentoDeRoteirosRouteImport.update({
    id: '/planejamento-de-roteiros',
    path: '/planejamento-de-roteiros',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdIndisponibilidadeDeElencoRoute =
  ProtectedProgramIdIndisponibilidadeDeElencoRouteImport.update({
    id: '/indisponibilidade-de-elenco',
    path: '/indisponibilidade-de-elenco',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdIndicadoresRoute =
  ProtectedProgramIdIndicadoresRouteImport.update({
    id: '/indicadores',
    path: '/indicadores',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdFotosRoute = ProtectedProgramIdFotosRouteImport.update({
  id: '/fotos',
  path: '/fotos',
  getParentRoute: () => ProtectedProgramIdRoute,
} as any)
const ProtectedProgramIdCapitulosECenasRoute =
  ProtectedProgramIdCapitulosECenasRouteImport.update({
    id: '/capitulos-e-cenas',
    path: '/capitulos-e-cenas',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdEprodIndexRoute =
  ProtectedProgramIdEprodIndexRouteImport.update({
    id: '/eprod/',
    path: '/eprod/',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdDecupagensFigurinoRoute =
  ProtectedProgramIdDecupagensFigurinoRouteImport.update({
    id: '/decupagens/figurino',
    path: '/decupagens/figurino',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdDecupagensEfeitosRoute =
  ProtectedProgramIdDecupagensEfeitosRouteImport.update({
    id: '/decupagens/efeitos',
    path: '/decupagens/efeitos',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdDecupagensContinuidadeRoute =
  ProtectedProgramIdDecupagensContinuidadeRouteImport.update({
    id: '/decupagens/continuidade',
    path: '/decupagens/continuidade',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdDecupagensArteRoute =
  ProtectedProgramIdDecupagensArteRouteImport.update({
    id: '/decupagens/arte',
    path: '/decupagens/arte',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdDecupagensBasicaIndexRoute =
  ProtectedProgramIdDecupagensBasicaIndexRouteImport.update({
    id: '/decupagens/basica/',
    path: '/decupagens/basica/',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdEprodScriptIdPainelRoute =
  ProtectedProgramIdEprodScriptIdPainelRouteImport.update({
    id: '/eprod/$scriptId/painel',
    path: '/eprod/$scriptId/painel',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)
const ProtectedProgramIdDecupagensBasicaChapterNumberRoute =
  ProtectedProgramIdDecupagensBasicaChapterNumberRouteImport.update({
    id: '/decupagens/basica/$chapterNumber',
    path: '/decupagens/basica/$chapterNumber',
    getParentRoute: () => ProtectedProgramIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ativar-painel-operacao': typeof AtivarPainelOperacaoRoute
  '/auth': typeof AuthRoute
  '/forbidden': typeof ForbiddenRoute
  '/$programId': typeof ProtectedProgramIdRouteWithChildren
  '/inicio': typeof ProtectedInicioRoute
  '/$programId/capitulos-e-cenas': typeof ProtectedProgramIdCapitulosECenasRoute
  '/$programId/fotos': typeof ProtectedProgramIdFotosRoute
  '/$programId/indicadores': typeof ProtectedProgramIdIndicadoresRoute
  '/$programId/indisponibilidade-de-elenco': typeof ProtectedProgramIdIndisponibilidadeDeElencoRoute
  '/$programId/planejamento-de-roteiros': typeof ProtectedProgramIdPlanejamentoDeRoteirosRoute
  '/$programId/relatorios': typeof ProtectedProgramIdRelatoriosRoute
  '/$programId/roteiros-da-semana': typeof ProtectedProgramIdRoteirosDaSemanaRoute
  '/$programId/visoes': typeof ProtectedProgramIdVisoesRoute
  '/$programId/decupagens/arte': typeof ProtectedProgramIdDecupagensArteRoute
  '/$programId/decupagens/continuidade': typeof ProtectedProgramIdDecupagensContinuidadeRoute
  '/$programId/decupagens/efeitos': typeof ProtectedProgramIdDecupagensEfeitosRoute
  '/$programId/decupagens/figurino': typeof ProtectedProgramIdDecupagensFigurinoRoute
  '/$programId/eprod': typeof ProtectedProgramIdEprodIndexRoute
  '/$programId/decupagens/basica/$chapterNumber': typeof ProtectedProgramIdDecupagensBasicaChapterNumberRoute
  '/$programId/eprod/$scriptId/painel': typeof ProtectedProgramIdEprodScriptIdPainelRoute
  '/$programId/decupagens/basica': typeof ProtectedProgramIdDecupagensBasicaIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ativar-painel-operacao': typeof AtivarPainelOperacaoRoute
  '/auth': typeof AuthRoute
  '/forbidden': typeof ForbiddenRoute
  '/$programId': typeof ProtectedProgramIdRouteWithChildren
  '/inicio': typeof ProtectedInicioRoute
  '/$programId/capitulos-e-cenas': typeof ProtectedProgramIdCapitulosECenasRoute
  '/$programId/fotos': typeof ProtectedProgramIdFotosRoute
  '/$programId/indicadores': typeof ProtectedProgramIdIndicadoresRoute
  '/$programId/indisponibilidade-de-elenco': typeof ProtectedProgramIdIndisponibilidadeDeElencoRoute
  '/$programId/planejamento-de-roteiros': typeof ProtectedProgramIdPlanejamentoDeRoteirosRoute
  '/$programId/relatorios': typeof ProtectedProgramIdRelatoriosRoute
  '/$programId/roteiros-da-semana': typeof ProtectedProgramIdRoteirosDaSemanaRoute
  '/$programId/visoes': typeof ProtectedProgramIdVisoesRoute
  '/$programId/decupagens/arte': typeof ProtectedProgramIdDecupagensArteRoute
  '/$programId/decupagens/continuidade': typeof ProtectedProgramIdDecupagensContinuidadeRoute
  '/$programId/decupagens/efeitos': typeof ProtectedProgramIdDecupagensEfeitosRoute
  '/$programId/decupagens/figurino': typeof ProtectedProgramIdDecupagensFigurinoRoute
  '/$programId/eprod': typeof ProtectedProgramIdEprodIndexRoute
  '/$programId/decupagens/basica/$chapterNumber': typeof ProtectedProgramIdDecupagensBasicaChapterNumberRoute
  '/$programId/eprod/$scriptId/painel': typeof ProtectedProgramIdEprodScriptIdPainelRoute
  '/$programId/decupagens/basica': typeof ProtectedProgramIdDecupagensBasicaIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/ativar-painel-operacao': typeof AtivarPainelOperacaoRoute
  '/auth': typeof AuthRoute
  '/forbidden': typeof ForbiddenRoute
  '/_protected/$programId': typeof ProtectedProgramIdRouteWithChildren
  '/_protected/inicio': typeof ProtectedInicioRoute
  '/_protected/$programId/capitulos-e-cenas': typeof ProtectedProgramIdCapitulosECenasRoute
  '/_protected/$programId/fotos': typeof ProtectedProgramIdFotosRoute
  '/_protected/$programId/indicadores': typeof ProtectedProgramIdIndicadoresRoute
  '/_protected/$programId/indisponibilidade-de-elenco': typeof ProtectedProgramIdIndisponibilidadeDeElencoRoute
  '/_protected/$programId/planejamento-de-roteiros': typeof ProtectedProgramIdPlanejamentoDeRoteirosRoute
  '/_protected/$programId/relatorios': typeof ProtectedProgramIdRelatoriosRoute
  '/_protected/$programId/roteiros-da-semana': typeof ProtectedProgramIdRoteirosDaSemanaRoute
  '/_protected/$programId/visoes': typeof ProtectedProgramIdVisoesRoute
  '/_protected/$programId/decupagens/arte': typeof ProtectedProgramIdDecupagensArteRoute
  '/_protected/$programId/decupagens/continuidade': typeof ProtectedProgramIdDecupagensContinuidadeRoute
  '/_protected/$programId/decupagens/efeitos': typeof ProtectedProgramIdDecupagensEfeitosRoute
  '/_protected/$programId/decupagens/figurino': typeof ProtectedProgramIdDecupagensFigurinoRoute
  '/_protected/$programId/eprod/': typeof ProtectedProgramIdEprodIndexRoute
  '/_protected/$programId/decupagens/basica/$chapterNumber': typeof ProtectedProgramIdDecupagensBasicaChapterNumberRoute
  '/_protected/$programId/eprod/$scriptId/painel': typeof ProtectedProgramIdEprodScriptIdPainelRoute
  '/_protected/$programId/decupagens/basica/': typeof ProtectedProgramIdDecupagensBasicaIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ativar-painel-operacao'
    | '/auth'
    | '/forbidden'
    | '/$programId'
    | '/inicio'
    | '/$programId/capitulos-e-cenas'
    | '/$programId/fotos'
    | '/$programId/indicadores'
    | '/$programId/indisponibilidade-de-elenco'
    | '/$programId/planejamento-de-roteiros'
    | '/$programId/relatorios'
    | '/$programId/roteiros-da-semana'
    | '/$programId/visoes'
    | '/$programId/decupagens/arte'
    | '/$programId/decupagens/continuidade'
    | '/$programId/decupagens/efeitos'
    | '/$programId/decupagens/figurino'
    | '/$programId/eprod'
    | '/$programId/decupagens/basica/$chapterNumber'
    | '/$programId/eprod/$scriptId/painel'
    | '/$programId/decupagens/basica'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ativar-painel-operacao'
    | '/auth'
    | '/forbidden'
    | '/$programId'
    | '/inicio'
    | '/$programId/capitulos-e-cenas'
    | '/$programId/fotos'
    | '/$programId/indicadores'
    | '/$programId/indisponibilidade-de-elenco'
    | '/$programId/planejamento-de-roteiros'
    | '/$programId/relatorios'
    | '/$programId/roteiros-da-semana'
    | '/$programId/visoes'
    | '/$programId/decupagens/arte'
    | '/$programId/decupagens/continuidade'
    | '/$programId/decupagens/efeitos'
    | '/$programId/decupagens/figurino'
    | '/$programId/eprod'
    | '/$programId/decupagens/basica/$chapterNumber'
    | '/$programId/eprod/$scriptId/painel'
    | '/$programId/decupagens/basica'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/ativar-painel-operacao'
    | '/auth'
    | '/forbidden'
    | '/_protected/$programId'
    | '/_protected/inicio'
    | '/_protected/$programId/capitulos-e-cenas'
    | '/_protected/$programId/fotos'
    | '/_protected/$programId/indicadores'
    | '/_protected/$programId/indisponibilidade-de-elenco'
    | '/_protected/$programId/planejamento-de-roteiros'
    | '/_protected/$programId/relatorios'
    | '/_protected/$programId/roteiros-da-semana'
    | '/_protected/$programId/visoes'
    | '/_protected/$programId/decupagens/arte'
    | '/_protected/$programId/decupagens/continuidade'
    | '/_protected/$programId/decupagens/efeitos'
    | '/_protected/$programId/decupagens/figurino'
    | '/_protected/$programId/eprod/'
    | '/_protected/$programId/decupagens/basica/$chapterNumber'
    | '/_protected/$programId/eprod/$scriptId/painel'
    | '/_protected/$programId/decupagens/basica/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  AtivarPainelOperacaoRoute: typeof AtivarPainelOperacaoRoute
  AuthRoute: typeof AuthRoute
  ForbiddenRoute: typeof ForbiddenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ativar-painel-operacao': {
      id: '/ativar-painel-operacao'
      path: '/ativar-painel-operacao'
      fullPath: '/ativar-painel-operacao'
      preLoaderRoute: typeof AtivarPainelOperacaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/inicio': {
      id: '/_protected/inicio'
      path: '/inicio'
      fullPath: '/inicio'
      preLoaderRoute: typeof ProtectedInicioRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/$programId': {
      id: '/_protected/$programId'
      path: '/$programId'
      fullPath: '/$programId'
      preLoaderRoute: typeof ProtectedProgramIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/$programId/visoes': {
      id: '/_protected/$programId/visoes'
      path: '/visoes'
      fullPath: '/$programId/visoes'
      preLoaderRoute: typeof ProtectedProgramIdVisoesRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/roteiros-da-semana': {
      id: '/_protected/$programId/roteiros-da-semana'
      path: '/roteiros-da-semana'
      fullPath: '/$programId/roteiros-da-semana'
      preLoaderRoute: typeof ProtectedProgramIdRoteirosDaSemanaRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/relatorios': {
      id: '/_protected/$programId/relatorios'
      path: '/relatorios'
      fullPath: '/$programId/relatorios'
      preLoaderRoute: typeof ProtectedProgramIdRelatoriosRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/planejamento-de-roteiros': {
      id: '/_protected/$programId/planejamento-de-roteiros'
      path: '/planejamento-de-roteiros'
      fullPath: '/$programId/planejamento-de-roteiros'
      preLoaderRoute: typeof ProtectedProgramIdPlanejamentoDeRoteirosRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/indisponibilidade-de-elenco': {
      id: '/_protected/$programId/indisponibilidade-de-elenco'
      path: '/indisponibilidade-de-elenco'
      fullPath: '/$programId/indisponibilidade-de-elenco'
      preLoaderRoute: typeof ProtectedProgramIdIndisponibilidadeDeElencoRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/indicadores': {
      id: '/_protected/$programId/indicadores'
      path: '/indicadores'
      fullPath: '/$programId/indicadores'
      preLoaderRoute: typeof ProtectedProgramIdIndicadoresRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/fotos': {
      id: '/_protected/$programId/fotos'
      path: '/fotos'
      fullPath: '/$programId/fotos'
      preLoaderRoute: typeof ProtectedProgramIdFotosRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/capitulos-e-cenas': {
      id: '/_protected/$programId/capitulos-e-cenas'
      path: '/capitulos-e-cenas'
      fullPath: '/$programId/capitulos-e-cenas'
      preLoaderRoute: typeof ProtectedProgramIdCapitulosECenasRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/eprod/': {
      id: '/_protected/$programId/eprod/'
      path: '/eprod'
      fullPath: '/$programId/eprod'
      preLoaderRoute: typeof ProtectedProgramIdEprodIndexRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/decupagens/figurino': {
      id: '/_protected/$programId/decupagens/figurino'
      path: '/decupagens/figurino'
      fullPath: '/$programId/decupagens/figurino'
      preLoaderRoute: typeof ProtectedProgramIdDecupagensFigurinoRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/decupagens/efeitos': {
      id: '/_protected/$programId/decupagens/efeitos'
      path: '/decupagens/efeitos'
      fullPath: '/$programId/decupagens/efeitos'
      preLoaderRoute: typeof ProtectedProgramIdDecupagensEfeitosRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/decupagens/continuidade': {
      id: '/_protected/$programId/decupagens/continuidade'
      path: '/decupagens/continuidade'
      fullPath: '/$programId/decupagens/continuidade'
      preLoaderRoute: typeof ProtectedProgramIdDecupagensContinuidadeRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/decupagens/arte': {
      id: '/_protected/$programId/decupagens/arte'
      path: '/decupagens/arte'
      fullPath: '/$programId/decupagens/arte'
      preLoaderRoute: typeof ProtectedProgramIdDecupagensArteRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/decupagens/basica/': {
      id: '/_protected/$programId/decupagens/basica/'
      path: '/decupagens/basica'
      fullPath: '/$programId/decupagens/basica'
      preLoaderRoute: typeof ProtectedProgramIdDecupagensBasicaIndexRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/eprod/$scriptId/painel': {
      id: '/_protected/$programId/eprod/$scriptId/painel'
      path: '/eprod/$scriptId/painel'
      fullPath: '/$programId/eprod/$scriptId/painel'
      preLoaderRoute: typeof ProtectedProgramIdEprodScriptIdPainelRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
    '/_protected/$programId/decupagens/basica/$chapterNumber': {
      id: '/_protected/$programId/decupagens/basica/$chapterNumber'
      path: '/decupagens/basica/$chapterNumber'
      fullPath: '/$programId/decupagens/basica/$chapterNumber'
      preLoaderRoute: typeof ProtectedProgramIdDecupagensBasicaChapterNumberRouteImport
      parentRoute: typeof ProtectedProgramIdRoute
    }
  }
}

interface ProtectedProgramIdRouteChildren {
  ProtectedProgramIdCapitulosECenasRoute: typeof ProtectedProgramIdCapitulosECenasRoute
  ProtectedProgramIdFotosRoute: typeof ProtectedProgramIdFotosRoute
  ProtectedProgramIdIndicadoresRoute: typeof ProtectedProgramIdIndicadoresRoute
  ProtectedProgramIdIndisponibilidadeDeElencoRoute: typeof ProtectedProgramIdIndisponibilidadeDeElencoRoute
  ProtectedProgramIdPlanejamentoDeRoteirosRoute: typeof ProtectedProgramIdPlanejamentoDeRoteirosRoute
  ProtectedProgramIdRelatoriosRoute: typeof ProtectedProgramIdRelatoriosRoute
  ProtectedProgramIdRoteirosDaSemanaRoute: typeof ProtectedProgramIdRoteirosDaSemanaRoute
  ProtectedProgramIdVisoesRoute: typeof ProtectedProgramIdVisoesRoute
  ProtectedProgramIdDecupagensArteRoute: typeof ProtectedProgramIdDecupagensArteRoute
  ProtectedProgramIdDecupagensContinuidadeRoute: typeof ProtectedProgramIdDecupagensContinuidadeRoute
  ProtectedProgramIdDecupagensEfeitosRoute: typeof ProtectedProgramIdDecupagensEfeitosRoute
  ProtectedProgramIdDecupagensFigurinoRoute: typeof ProtectedProgramIdDecupagensFigurinoRoute
  ProtectedProgramIdEprodIndexRoute: typeof ProtectedProgramIdEprodIndexRoute
  ProtectedProgramIdDecupagensBasicaChapterNumberRoute: typeof ProtectedProgramIdDecupagensBasicaChapterNumberRoute
  ProtectedProgramIdEprodScriptIdPainelRoute: typeof ProtectedProgramIdEprodScriptIdPainelRoute
  ProtectedProgramIdDecupagensBasicaIndexRoute: typeof ProtectedProgramIdDecupagensBasicaIndexRoute
}

const ProtectedProgramIdRouteChildren: ProtectedProgramIdRouteChildren = {
  ProtectedProgramIdCapitulosECenasRoute:
    ProtectedProgramIdCapitulosECenasRoute,
  ProtectedProgramIdFotosRoute: ProtectedProgramIdFotosRoute,
  ProtectedProgramIdIndicadoresRoute: ProtectedProgramIdIndicadoresRoute,
  ProtectedProgramIdIndisponibilidadeDeElencoRoute:
    ProtectedProgramIdIndisponibilidadeDeElencoRoute,
  ProtectedProgramIdPlanejamentoDeRoteirosRoute:
    ProtectedProgramIdPlanejamentoDeRoteirosRoute,
  ProtectedProgramIdRelatoriosRoute: ProtectedProgramIdRelatoriosRoute,
  ProtectedProgramIdRoteirosDaSemanaRoute:
    ProtectedProgramIdRoteirosDaSemanaRoute,
  ProtectedProgramIdVisoesRoute: ProtectedProgramIdVisoesRoute,
  ProtectedProgramIdDecupagensArteRoute: ProtectedProgramIdDecupagensArteRoute,
  ProtectedProgramIdDecupagensContinuidadeRoute:
    ProtectedProgramIdDecupagensContinuidadeRoute,
  ProtectedProgramIdDecupagensEfeitosRoute:
    ProtectedProgramIdDecupagensEfeitosRoute,
  ProtectedProgramIdDecupagensFigurinoRoute:
    ProtectedProgramIdDecupagensFigurinoRoute,
  ProtectedProgramIdEprodIndexRoute: ProtectedProgramIdEprodIndexRoute,
  ProtectedProgramIdDecupagensBasicaChapterNumberRoute:
    ProtectedProgramIdDecupagensBasicaChapterNumberRoute,
  ProtectedProgramIdEprodScriptIdPainelRoute:
    ProtectedProgramIdEprodScriptIdPainelRoute,
  ProtectedProgramIdDecupagensBasicaIndexRoute:
    ProtectedProgramIdDecupagensBasicaIndexRoute,
}

const ProtectedProgramIdRouteWithChildren =
  ProtectedProgramIdRoute._addFileChildren(ProtectedProgramIdRouteChildren)

interface ProtectedRouteChildren {
  ProtectedProgramIdRoute: typeof ProtectedProgramIdRouteWithChildren
  ProtectedInicioRoute: typeof ProtectedInicioRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedProgramIdRoute: ProtectedProgramIdRouteWithChildren,
  ProtectedInicioRoute: ProtectedInicioRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  AtivarPainelOperacaoRoute: AtivarPainelOperacaoRoute,
  AuthRoute: AuthRoute,
  ForbiddenRoute: ForbiddenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
